<template>
  <form @submit.prevent class="form-horizontal" role="form" novalidate="novalidate">

    <div class="form-group form-multiselect" id="select-entity" v-if="!isSingle">
      <select-entity :entities="manageableEntities"
                     :labelEntity="$t('Offers.filters.entities') + '*'"
                     :entitySelector="'entity_id'"
                     :colLabel="'col-md-4'"
                     :colSelect="'col-md-8'"
                     :marginEntity="'m-t-0'"
                     @entity-changed="displayForm"
                     :disabled="!canEditMode"
                     :preselectedEntityId="offer.entity.id || selectedEntityId"
                  />
    </div>

    <div v-if="loadFormOffer">
      <ul class="nav nav-tabs nav-tabs-fillup hidden-sm-down" data-init-reponsive-tabs="dropdownfx">
        <li class="nav-item col-4">
          <a href="#" :class="{ active: true }" data-toggle="tab" data-target="#offer-form" aria-expanded="true">
            <span>{{ $t('OfferForm.nav.form') }}</span>
          </a>
        </li>
        <li class="nav-item col-4" v-if="validateOffer()">
          <a href="#" :class="{ active: false }" data-toggle="tab" data-target="#select-candidates" @click="updateCandidates" class="" aria-expanded="false">
            <span>{{ $t('OfferForm.nav.select') }}  ( {{  selectedCandidates }} / {{ potentialCandidatesCount }} )</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <div class="tab-pane slide-left" :class="{ active: true }" id="offer-form" aria-expanded="true">
        <offer-informations-form :offer="offer"
                                 :selectedEntityId="selectedEntityId"
                                 @managersToAddInCopy="addManagersInCopy"
                                 @createOffersByEachPeriod="updateCreateOffersByEachPeriod"
                                 @updateReplacementMotive="updateReplacementMotive"
                                 @removeOfferPeriod="removeOfferPeriod" />
        <template v-if="selectedEntityId && entityCustomFields">
          <entity-custom-fields :key="entityCustomFieldsKey"  v-bind:custom-fields="entityCustomFields"
                                v-bind:page-type="'request'"
                                @user-custom-fields="setOfferCustomFields"
                                />
        </template>
      </div>
      
      <div class="tab-pane slide-left" :class="{ active: false }" id="select-candidates" aria-expanded="false">
        <select-candidates ref="selectCandidatesRef"
                           :candidatesCount="potentialCandidatesCount"
                           :offer="offer"
                           :isSingle="isSingle"
                           @pageChanged="candidatesListPageChanged"
                           @updateCheckedValue="addPotentialCandidatesList"
                           @selectedCandidates="updateSelectedCandidates"
                           :entityId="offer.entity.id"
        />
      </div>
    </div>

    <div class="pull-right row" v-if="loadFormOffer">
      <router-link :to="backPage" class="btn btn-default btn-cons m-t-10" v-bind:class="{ disabled: isLoader }">{{ $t("buttons.cancel") }}</router-link>
      <button v-if="showSaveDraftBtn" @click="saveDraft" class="btn btn-secondary-dark btn-cons m-t-10 btn-save-draft" :disabled="isLoader">{{ $t("OfferForm.buttons.save_draft") }}</button>
      <button v-if="showPublishBtn" @click="publish" class="btn btn-primary btn-cons m-t-10 btn-publish" :disabled="isLoader">
        <span class="fa fa-spinner fa-spin" v-show="isLoader"></span>
        {{ $t("OfferForm.buttons.publish") }}
      </button>
      <button v-if="showValidateBtn" @click="saveChanges" class="btn btn-primary btn-cons m-t-10" :disabled="isLoader">{{ $t("buttons.validate") }}</button>
      <button v-if="showRepublishBtn" @click.prevent="republish" class="btn btn-primary btn-cons m-t-10 btn-republish">{{ $t("OfferForm.buttons.publish") }}</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OfferInformationsForm from "./OfferInformationsForm"
import SelectCandidates from "./SelectCandidates"
import { offerStatus } from '@/settings/offers'
import RepublishOfferConfirmation from '@/components/offers/RepublishOfferConfirmation'
import PublishOfferWithoutCandidateConfirmation from '@/components/offers/PublishOfferWithoutCandidateConfirmation'
import SelectEntity from '@/components/common/SelectEntity'
import ie_mixin from '@/mixin/ie'
import _ from 'lodash'
import AtInternetManager from '@/helpers/at_internet/manage_requests'
import { postOfferLogs } from '@/backend/offers.js'
import EntityCustomFields from '@/components/form/EntityCustomFields'

const REPUBLISH_CONFIRMATION_VIEW_NAME = 'RepublishOfferConfirmation'
const PUBLISH_CONFIRMATION_WITHOUT_CANDIDATES_VIEW_NAME = 'PublishOfferWithoutCandidateConfirmation'

export default {
  name: 'OfferForm',
  data: function(){
    return {
      createOffersByEachPeriod: false,
      candidatesListType: 'default',
      openedToCandidatesFrom: 'intern',
      isLoader: false,
      isLoadForm: false,
      isSingle: false,
      selectedHub: null,
      groupedServicesList: false,
      managersToAddInCopy: [],
      potentialCandidatesList: {},
      selectedCandidates: 0,
      entityCustomFields: false,
      entityCustomFieldsKey: ''
    }
  },
  components: { SelectEntity, OfferInformationsForm, SelectCandidates, EntityCustomFields },
  props: ['offerId'],
  mixins: [ie_mixin],
  computed: {
    ...mapGetters({
      offer: 'offers/offer',
      currentUser: 'auth/currentUser',
      manageableHubs: 'users/manageableHubs',
      occupationsOptions: 'users/manageableOccupations',
      allServices: 'users/allServices',
      manageableEntities: 'users/manageableEntities',
      loadFormOffer: 'offers/loadFormOffer',
      potentialCandidates: 'offers/candidatesList',
      potentialCandidatesIds: 'offers/candidatesIdsList'
    }),
    servicesOptions(){
      var manageableServicesIds = this.manageableServices.map(service => service.id)
      var otherServices = this.allServices.filter(service => !manageableServicesIds.includes(service.id));
      var options = [{
        type: this.$i18n.t('OfferForm.my_offers'),
        services: this.manageableServices
      }];
      if(otherServices.length > 0){
        options.push({
          type: this.$i18n.t('OfferForm.all_offers'),
          services: otherServices
        })
      }
      return options;
    },
    backPage(){
      return this.offer.id ? { name: 'AdminOffer', params: { id: this.offer.id } }: { name: 'Dashboard' }
    },
    canEditMode() {
      return this.offer.id == undefined
    },
    offerIsPublished(){
      return this.offer.status == offerStatus.published
    },
    showSaveDraftBtn(){
      return !this.offerIsPublished && this.offer.status != offerStatus.validated
    },
    showPublishBtn(){
      return !this.offerIsPublished && this.offer.status != offerStatus.validated
    },
    showRepublishBtn(){
      return this.offerIsPublished
    },
    showValidateBtn() {
      return this.offer.status == offerStatus.validated
    },
    loadForm() {
      return this.isSingle || (!this.isSingle && this.isLoadForm)
    },
    potentialCandidatesCount() {
      return Object.keys(this.potentialCandidatesIds).length
    },
    selectedEntityId() {
      return this.offer.entity ? this.offer.entity.id : null
    }
  },
  watch: {
    openedToCandidatesFrom(newValue, _){
      this.offer.resource_type = newValue == 'intern_with_proposed_candidates' || newValue ==  'intern_of_concerned_hub' ? 'intern' : this.openedToCandidatesFrom;
      this.offer.include_proposed_candidates = this.openedToCandidatesFrom == 'intern' || this.openedToCandidatesFrom == 'intern_of_concerned_hub' ? false : true;
      if(this.offer.entity.hubs.length > 1){
        this.offer.include_hub_services = this.openedToCandidatesFrom != 'all' && this.openedToCandidatesFrom != 'intern_of_concerned_hub' ? false : true;
      }
      if(newValue == 'intern' || newValue =='intern_with_proposed_candidates' || newValue =='intern_of_concerned_hub') {
        this.resetContractInformationsFields()
      }
    },
    manageableHubs(newValue, _) {
      if(newValue.length == 1) this.selectedHub = newValue[0];
    },
    offer: {
      handler() {
        this.loadCandidateList()
      },
      deep: true
    },
    'offer.entity': {
      handler() {
       this.setCustomFields();
      }
    },
    potentialCandidatesIds() {
      this.selectedCandidates = 0
      Object.keys(this.potentialCandidatesIds).forEach((id) => {
        if (this.potentialCandidatesIds[id]) {
          this.selectedCandidates++
        }
        if (this.potentialCandidatesList[id] != undefined && !this.potentialCandidatesList[id]) {
          this.selectedCandidates--
        }
      })
    }
  },
  methods: {
    ...mapActions({
      saveDraftAction: 'offers/saveDraft',
      publishAction: 'offers/publish',
      republishAction: 'offers/republish',
      setCandidatesListPageAction: 'offers/setCandidatesListPage',
      resetPotentialCandidatesAction: 'offers/resetPotentialCandidates',
      initManageableOptionsAction: 'users/initManageableOptions',
      getManagersEntityOptionsAction: 'users/getManagersEntityOptions',
      getManagerInCopy: 'offers/getManagerInCopy',
      initReplacementMotivesAction: 'replacementMotives/initReplacementMotives',
      getPotentialCandidatesAction: 'offers/getPotentialCandidates',
      messageAction: 'message/enable',
      getOffer: 'offers/getOffer',
      resetOffer: 'offers/reset',
      setLoadForm: 'offers/setLoadForm',
      setEntityOffer: 'offers/setEntityOffer',
      searchPotentialCandidates: 'offers/searchPotentialCandidates'
    }),
    setOfferCustomFields(custom_fields){
      this.offer.custom_fields = custom_fields
    },
    validateOffer() {
      return ((this.offer.status == "published" || this.offer.status == "draft") && !this.offer.is_expired)
                || this.offer.status == undefined
    },
    publishOffer() {
      this.publishAction({
        offer: this.offer,
        createOffersByEachPeriod: this.createOffersByEachPeriod,
        managersToAddInCopy: this.managersToAddInCopy,
        potentialCandidatesList: this.potentialCandidatesList
      })
      .then(() => {
        this.isLoader = false;
        AtInternetManager.sendNumberRequestsMadeEvent();
        this.redirectToListPath();
        this.messageAction({ type: 'success', content: this.$i18n.t('messages.offers.published_success') });
      })
      .catch(() => {
        this.isLoader = false;
      });
    },
    rePublishOffer(self) {
      this.$dialog.alert("republish", {
        view: REPUBLISH_CONFIRMATION_VIEW_NAME,
        html: true,
        animation: 'fade',
        backdropClose: true
      })
      .then(dialog => {
        let options = {
          resend_notification_type: dialog.data,
          create_offers_for_each_period: self.createOffersByEachPeriod
        }
        self.republishAction({
          offer: self.offer,
          options: options,
          managersToAddInCopy: self.managersToAddInCopy,
          potentialCandidatesList: self.potentialCandidatesList
        })
        .then(() => {
          self.redirectToListPath();
          if (self.isIE) {
            self.$router.go(0);
          }
          self.messageAction({ type: 'success', content: self.$i18n.t('messages.offers.published_success') });
        });
      });
    },
    saveDraft(){
      this.save(this.redirectToListPath(), this.$i18n.t('messages.offers.saved_draft_success'))
    },
    saveChanges(){
      this.save(this.redirectToHistorical(), this.$i18n.t('messages.offers.saved_draft_success'))
    },
    save(redirectPath, message){
      var self = this;
      this.formatCustomFields();
      this.$validator.validateAll().then((result) => {
        if(result){
          self.saveDraftAction({ offer: self.offer,
                                 createOffersByEachPeriod: self.createOffersByEachPeriod,
                                 managersToAddInCopy: self.managersToAddInCopy,
                                 potentialCandidatesList: self.potentialCandidatesList })
          .then(() => {
            redirectPath
            self.messageAction({ type: 'success', content: message})
          })
        }
      });
    },
    showConfirmationDialog(actionMethod, loaderBool, self) {
      this.$dialog.alert(actionMethod, {
        view: "PublishOfferWithoutCandidateConfirmation",
        html: true,
        animation: 'fade',
        backdropClose: true
      }).then(dialog => {
        if (dialog.data === 'confirm') {
          this.isLoader = loaderBool;
          this[actionMethod](self);
          // logs créer pour éllucider le mystère des offres sans candidats, à supprimer
          postOfferLogs(actionMethod, self.offer);
          // Fin logs
        }
      });
    },
    publish() {
      var self = this;
      this.formatCustomFields();
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (self.selectedCandidates === 0) {
            this.showConfirmationDialog('publishOffer', true, self);
          } else {
            self.isLoader = true;
            self.publishOffer();
          }
        }
      });
    },
    republish() {
      var self = this;
      this.formatCustomFields();
      this.$validator.validateAll().then((result) => {
        if(result){
          if (self.selectedCandidates === 0) {
            this.showConfirmationDialog('rePublishOffer', false, self)
          } else {
            this.rePublishOffer(self);
          }
        }
      });
    },
    formatCustomFields() {
      if(!this.offer.custom_fields) {
        return;
      }
      var self = this;
      Object.keys(self.offer.custom_fields).forEach((key) => {
        if(typeof self.offer.custom_fields[key] === 'object' && self.offer.custom_fields[key].value) {
          self.offer.custom_fields[key] = self.offer.custom_fields[key].value;
        }
      })
    },
    loadDialogPublishConfirmation(){
      this.$dialog.registerComponent(PUBLISH_CONFIRMATION_WITHOUT_CANDIDATES_VIEW_NAME, PublishOfferWithoutCandidateConfirmation);
    },
    loadDialogRepublishConfirmation(){
      this.$dialog.registerComponent(REPUBLISH_CONFIRMATION_VIEW_NAME, RepublishOfferConfirmation);
    },
    redirectToListPath(){
      this.$router.push({ name: "Offers"});
    },
    redirectToHistorical(){
      this.$router.push({ name: "RequestHistories"});
    },
    candidatesListPageChanged: function(page){
      this.getPotentialCandidatesAction(
        {
          offer: this.offerPotentialCandidateParams(),
          page: page
        }
      );
      this.setCandidatesListPageAction(page)
    },
    offerPotentialCandidateParams(){
      let entityId
      if (this.isSingle && this.manageableEntities[0]) {
        entityId = this.manageableEntities[0].id
      } else {
        entityId = this.offer.entity.id
      }
      return {
        id: this.offer.id,
        resource_type: this.offer.resource_type,
        mode: this.offer.mode,
        replaced_service_id: this.offer.replaced_service.id,
        searched_occupation_ids: this.offer.searched_occupations.map(occupation => occupation.id),
        offer_periods_attributes: this.offer.offer_periods_attributes,
        include_proposed_candidates: this.offer.include_proposed_candidates,
        include_hub_services: this.offer.include_hub_services,
        entity_id: entityId
      }
    },
    getCurrentDateIfNull: function(date){
      return date == null ? new Date() : date
    },
    addManagersInCopy: function(value) {
      this.managersToAddInCopy = value
    },
    updateReplacementMotive: function(newValue) {
      this.offer.replacement_detail_attributes.replacement_motive_id = null;
      if(typeof newValue != 'undefined' && newValue != null){
        this.offer.replacement_detail_attributes.replacement_motive_id = newValue.id;
      }
    },
    updateCreateOffersByEachPeriod: function(value) {
      this.createOffersByEachPeriod = value
    },
    removeOfferPeriod(index){
      let offerPeriod = this.offer.offer_periods_attributes[index]

      if (offerPeriod.id) {
        offerPeriod._destroy = true
      } else {
        this.$delete(this.offer.offer_periods_attributes, index)
      }
    },
    updateCandidates() {
      if (this.offer.replaced_service.id != undefined) {
        const selectCandidatesComponent = this.$refs.selectCandidatesRef;
        selectCandidatesComponent.pageChanged()
        selectCandidatesComponent.countCandidates()
        selectCandidatesComponent.checkboxAllCandidates()
      }
    },
    displayForm: function(value){
      this.selectedHub = null
      this.isLoadForm = value['id'] > 0
      this.resetOffer()
      this.resetPotentialCandidatesAction()
      this.offer.entity = value
      if (this.loadForm) {
        this.setLoadForm(true)
      }
      this.initManageableOptionsAction({ entityId: this.offer.entity.id });
      this.getManagersEntityOptionsAction({entityId: this.offer.entity.id})
    },
    updateSelectedHub: function(value){
      if (value != null) {
        this.initManageableOptionsAction({ entityId: this.offer.entity.id, hubIds: [this.selectedHub.id] });
      } else {
        this.initManageableOptionsAction({ entityId: this.offer.entity.id });
      }
    },
    addPotentialCandidatesList: function(candidates) {
      this.potentialCandidatesList = candidates
    },
    updateSelectedCandidates: function(selectedCandidates) {
      if (selectedCandidates != undefined) {
        this.selectedCandidates = selectedCandidates
      }
    },
    loadCandidateList: function() {
      if (typeof this.offer.replaced_service != 'undefined' && typeof this.offer.searched_occupations != 'undefined') {
        this.setCandidatesListPageAction(1);
        let offerPotentialCandidateParams = this.offerPotentialCandidateParams()
        if (offerPotentialCandidateParams.searched_occupation_ids.length > 0 &&
          typeof offerPotentialCandidateParams.replaced_service_id != 'undefined') {
          this.getPotentialCandidatesAction({offer: offerPotentialCandidateParams})
        }
      }
    },
    selectChoiceSelection() {
      AtInternetManager.sendChoiceModeRequestEvent()
    },
    selectChoiceOpeningInterneService() {
      AtInternetManager.sendInternalDepartementOpeningEvent()
    },
    setCustomFields() {
      if (this.entityCustomFieldsKey == JSON.stringify(this.offer.entity.entity_custom_fields)) {
          return;
      }
      
      this.entityCustomFields = {
        configurations: this.offer.entity.entity_custom_fields,
        user: this.offer.id ? Object.fromEntries(Object.entries(this.offer.custom_fields).map(([key, value]) => [key, value.value])) : {}
      }
      this.entityCustomFieldsKey = JSON.stringify(this.offer.entity.entity_custom_fields);
    },
  },
  mounted: async function() {
    this.selectChoiceSelection();
    this.selectChoiceOpeningInterneService(),
    await this.$store.dispatch('users/getUserWithEntities')
      .then((response) => {
        if (response.entities.length == 1) {
          this.isSingle = true
          this.setLoadForm(true)
          this.offer.entity = response.entities[0];
          this.getManagersEntityOptionsAction({entityId: this.offer.entity.id})
        }
    })

    this.resetPotentialCandidatesAction();
    this.loadDialogPublishConfirmation();
    this.loadDialogRepublishConfirmation();

    if(this.offer.id || this.offer.entity.id) {
      this.setLoadForm(true)
    }

    if (this.offer.entity.entity_custom_fields){
      this.setCustomFields()
    }

  },
  destroyed() {
    this.resetOffer();
    this.setLoadForm(false);
  }
}
</script>

<style lang="scss" scoped>
  .offer-periods{
    display: block;
  }
  .contract-information {
    background-color: #eeefef;
    border-radius: 8px;
  }

  #select-entity {
    border-bottom: none;
  }

  @media (max-width: 767px) {
    .btn {
      width: 100%;
    }
    .btn-cons {
      margin-right: 0;
    }
    .col-md-4, .col-md-8 {
      padding-right: 0;
      padding-left: 0;
    }
  }

  a.disabled {
    pointer-events: none;
    cursor: default;
  }

  .table-title {
    span {
      padding-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/OfferForm.vue